import { useElements, useStripe } from '@stripe/react-stripe-js'
import { usePaymentStore } from '../store'

interface HandlePaymentOptions {
  onSuccess?: () => void
  onError?: (error: string) => void
}

export const usePayment = () => {
  const stripe = useStripe()
  const elements = useElements()
  const { isPending, isError, error, setPending, setError, reset } =
    usePaymentStore()

  const handlePayment = async (
    clientSecret: string | undefined,
    { onSuccess, onError }: HandlePaymentOptions,
  ) => {
    if (!stripe || !elements || !clientSecret) return

    reset()
    setPending(true)

    const { error: submitError } = await elements.submit()
    if (submitError) {
      setPending(false)
      setError(submitError.message || '')
      return onError?.(submitError.message || '')
    }

    const res = await stripe.confirmPayment({
      elements,
      clientSecret,
      redirect: 'if_required',
    })

    setPending(false)

    if (res?.error?.message) {
      setError(res.error.message)
      return onError?.(res.error.message)
    }

    if (res.paymentIntent) {
      return onSuccess?.()
    }
  }

  return { handlePayment, isPending, isError, error }
}
